import { render, staticRenderFns } from "./BlockSelectExamples.vue?vue&type=template&id=3823b277"
import script from "./BlockSelectExamples.vue?vue&type=script&lang=js"
export * from "./BlockSelectExamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports